// src/components/Projects.jsx
import { Link } from 'react-router-dom';
import { projectsData, PROJECT_CATEGORIES } from '../data/projects';

function ProjectPreview({ project }) {
  if (project.imgUrl) {
    return <img src={project.imgUrl} alt={`Aperçu ${project.title}`} loading="lazy" decoding="async" />;
  }

  return (
    <div className="project-preview-fallback">
      <span>{project.figmaUrl ? 'Voir sur Figma' : 'Bientôt'}</span>
    </div>
  );
}

function ProjectCard({ project }) {
  const cardContent = (
    <>
      <div className="project-info">
        <h3>{project.cardTitle ?? project.title}</h3>
        <p>{project.cardDesc ?? project.desc}</p>
      </div>
      <div className="project-preview">
        <ProjectPreview project={project} />
      </div>
    </>
  );

  if (project.placeholder) {
    return <div className="project project--placeholder">{cardContent}</div>;
  }

  if (project.external) {
    return (
      <a href={project.link} className="project" data-tilt target="_blank" rel="noopener noreferrer">
        {cardContent}
      </a>
    );
  }

  return (
    <Link to={project.link} className="project" data-tilt>
      {cardContent}
    </Link>
  );
}

export default function Projects() {
  return (
    <section id="work" className="section">
      <div className="section-header">
        <h2>projets</h2>
        <span className="section-line"></span>
      </div>

      {PROJECT_CATEGORIES.map((category) => {
        const items = projectsData.filter((project) => project.category === category.id);
        if (items.length === 0) return null;

        return (
          <div className="project-category" key={category.id}>
            <h3 className="project-category-title">{category.label}</h3>
            <div className="projects-grid">
              {items.map((project) => (
                <ProjectCard project={project} key={project.id} />
              ))}
            </div>
          </div>
        );
      })}
    </section>
  );
}
